import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useOutletContext } from 'react-router-dom'
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Portal,
} from '@mui/material'
import { map } from 'lodash'

import { CarEquipment, Dictionaries } from '../api/index'
import ButtonBox from '../components/ButtonBox'
import Section from '../components/Section'
import SectionHeader from '../components/SectionHeader'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import {
  AccessoriesIcon,
  ArrowLeft,
  ArrowRight,
  CancelIcon,
  CheckIcon,
  SaveIcon,
} from '../icons'

function ControlsEditCarEquipment() {
  const { controlId, portalRef, onCancelClick } = useOutletContext()
  const axiosPrivate = useAxiosPrivate()
  const navigate = useNavigate()
  const [values, setValues] = useState({})
  const [carEquipmentDictionary, setCarEquipmentDictionary] = useState(null)
  const [isBtnLoading, setIsBtnLoading] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    CarEquipment.getCarEquipment(axiosPrivate, controlId)
      .then(({ data }) => setValues(data))
      // eslint-disable-next-line no-console
      .catch((e) => console.error(e))

    Dictionaries.getCarEquipmentDictionary(axiosPrivate, controlId)
      .then(({ data }) => {
        setCarEquipmentDictionary(data)
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.error(e))
  }, [axiosPrivate, controlId])

  const handleChange = (e) => {
    const { name } = e.target

    setValues((prevState) => ({ ...prevState, [name]: !prevState[name] }))
  }

  const saveCarEquipment = (redirect) => (e) => {
    e.preventDefault()
    setIsBtnLoading(true)
    CarEquipment.saveCarEquipment(axiosPrivate, controlId, values)
      .then(() => {
        if (redirect) {
          navigate(redirect)
        }
      })
      // eslint-disable-next-line no-console
      .catch((er) => console.error(er))
      .finally(() => {
        setIsBtnLoading(false)
      })
  }

  return (
    <div>
      <Section>
        <SectionHeader
          icon={<AccessoriesIcon />}
          title={t('carEqTitle')}
          subtitle={t('carEqSubTitle')}
        />

        <Box>
          {map(carEquipmentDictionary, (item, key) => (
            <FormControl key={key} fullWidth>
              <FormControlLabel
                control={
                  <Checkbox
                    name={item.name}
                    value="1"
                    checked={values[item.name] || false}
                    onChange={handleChange}
                    disabled={!item.isActive}
                  />
                }
                label={item.label}
              />
            </FormControl>
          ))}
        </Box>
        <Portal container={portalRef.current}>
          <ButtonBox
            buttons={[
              {
                label: 'Wstecz',
                icon: <ArrowLeft fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: isBtnLoading,
                  onClick: saveCarEquipment(
                    `/controls/${controlId}/edit/interiorCondition`,
                  ),
                },
              },
              {
                label: t('backToListBtnLabel'),
                icon: <CancelIcon />,
                props: {
                  variant: 'outlined',
                  color: 'primary',
                  onClick: onCancelClick,
                },
              },
              {
                label: 'Zapisz',
                icon: <SaveIcon fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: isBtnLoading,
                  onClick: saveCarEquipment(false),
                },
              },
              {
                label: 'Zakończ',
                icon: <CheckIcon fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: isBtnLoading,
                  onClick: saveCarEquipment(`/controls/${controlId}/summary`),
                },
              },
              {
                label: t('nextBtnLabel'),
                icon: <ArrowRight fill="white" />,
                props: {
                  variant: 'contained',
                  color: 'primary',
                  loading: isBtnLoading,
                  onClick: saveCarEquipment(
                    `/controls/${controlId}/edit/tyres`,
                  ),
                },
              },
            ]}
          />
        </Portal>
      </Section>
    </div>
  )
}

export default ControlsEditCarEquipment
